module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "exe"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#exe"
    }
  }, [_vm._v("List of Excursuses")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush",
    attrs: {
      "id": "FE1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#E1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 1: A Note on the Language of Sense Perception")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#E2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 2: A Note on “From the Beginning” ("), _c('i', [_vm._v("ap’ archēs")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#E3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 3: A Note on the Meaning of “Fellowship” ("), _c('i', [_vm._v("koinōnia")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#E4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 4: A Note on the Use of First-Person Forms")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#E5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 5: A Note on Light and Darkness")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#E6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 6: A Note on Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#E7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 7: A Note on "), _c('i', [_vm._v("Hilasmos")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#E8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 8: A Note on “Children,” “Fathers,” and “Young Men”")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003a#E9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 9: A Note on Antichrist")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003a#E10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 10: A Note on "), _c('i', [_vm._v("Chrisma")]), _vm._v("—Spirit or Word?")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003a#E11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 11: A Note on the Teaching Authority of the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003a#E12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 12: A Note on God’s “Seed”")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003a#E13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 13: A Note on Sinless Perfectionism")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003a#E14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 14: A Note on the Role of the Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003a#E15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 15: A Note on "), _c('i', [_vm._v("Monogenēs")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003a#E16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 16: A Note on the Son’s Preexistence")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003a#E17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 17: A Note on God’s Invisibility")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003a#E18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 18: A Note on the Savior of the World")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003b#E19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 19: A Note on “Witness”")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003b#E20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 20: A Note on Eternal Life")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003b#E21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 21: A Note on Sins That Do and Do Not Lead to Death")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003b#E22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 22: A Note on the Bases of Assurance")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#E23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 23: A Note on Hospitality")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush2",
    attrs: {
      "id": "FE24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#E24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excursus 24: A Note on Love and Hate in the Christian Community")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36568726","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter002.vue
// module id = 69
// module chunks = 0